import { render } from "./AuthFooter.vue?vue&type=template&id=4fd12db8&ts=true"
import script from "./AuthFooter.vue?vue&type=script&lang=ts"
export * from "./AuthFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__